import { useContext } from 'react';

import { ChapterLearningStatus } from '../LearningStatus';
import useChapterLearningStatus from '../../hooks/useChapterLearningStatus';
import CourseContext from '../../contexts/courseContext';
import CourseChapterContext from '../../contexts/courseChapterContext';
import type { PartType } from '../../types';
import TocItemWrapper from './TocItemWrapper';

export interface Props {
  number: number;
  chapterPart: PartType;
  isOnHomePage: boolean;
  onClick?: () => void;
}

const ChapterTocItem = ({ number, chapterPart, isOnHomePage, onClick = () => {} }: Props) => {
  const { id, title, learningActivityStatus } = chapterPart;

  const { course } = useContext(CourseContext);
  const { categoryColor } = course;

  const { currentChapterId } = useContext(CourseChapterContext);

  const { status: chapterLearningStatus } = useChapterLearningStatus({
    id,
    initialStatus: learningActivityStatus,
    isOnHomePage,
  });

  const isCurrentDisplayed = id === Number(currentChapterId);

  const Icon = (
    <ChapterLearningStatus
      status={chapterLearningStatus}
      chapterIndex={number}
      color={categoryColor}
    />
  );

  return (
    <TocItemWrapper
      isCurrentDisplayed={isCurrentDisplayed}
      part={chapterPart}
      label={title}
      onClick={onClick}
      learningStatusIcon={Icon}
    />
  );
};

export default ChapterTocItem;
